export enum ExplorerDownloadType {
    csv = 'csv',
    pdf = 'pdf',
}



// WEBPACK FOOTER //
// ./src/models/configuration/explorer/ExplorerDownloadType.ts